import { render, staticRenderFns } from "./VendorRegion.vue?vue&type=template&id=3428a689"
import script from "./VendorRegion.vue?vue&type=script&lang=js"
export * from "./VendorRegion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports